import React, {Component} from "react";

export default class ProjectsInsights extends Component {
    render() {
        return (
            <>
            TODO:
                Should display user accounts
                    - Projects
                    - Projects Progress
                    - Most active projects based on:[issues, contributors, investors, tasks]
                    - My tasks per project
                    - My Contribution stats based on:[financial contributions, work hours/cost contributions
            </>
        );
    }
}